import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/legal-deviations/$domain',
)({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: location.href.replace('/legal-deviations/', '/contract-review/'),
      replace: true,
    });
  },
});
